import React from 'react';
import areaPositions, { MAP_IMAGE_SRC } from '../areaPositions';

// 루미아 섬 지도(공용). 모든 지역 이름을 그리고, 그 위에 레이어가 넘기는 마커(children)를 올린다.
// children의 마커는 position: absolute; left/top을 areaPositions의 % 값으로 주면 지도 위 그 지역에 놓인다.
// highlighted: 굵게 보여줄 지역 이름 집합(레이어가 정보를 올린 지역). 인라인 스타일만 쓴다(PiP는 별도 창이라 CSS가 없음).
export default function IslandMap({ highlighted = new Set(), children }) {
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <img src={MAP_IMAGE_SRC} alt="루미아 섬" style={{ width: '100%', display: 'block', borderRadius: 6 }} />
      {Object.entries(areaPositions).map(([name, pos]) => (
        <div
          key={`label-${name}`}
          style={{
            position: 'absolute', left: `${pos.left}%`, top: `${pos.top + 2.2}%`, transform: 'translateX(-50%)',
            fontSize: 10, fontWeight: highlighted.has(name) ? 'bold' : 'normal',
            color: highlighted.has(name) ? '#fff' : 'rgba(255,255,255,0.65)', backgroundColor: 'rgba(0,0,0,0.45)',
            padding: '0 3px', borderRadius: 3, whiteSpace: 'nowrap', pointerEvents: 'none',
          }}
        >
          {name}
        </div>
      ))}
      {children}
    </div>
  );
}
